import { type DefaultRootState } from 'react-redux';
import { selectCurrentUser } from '@bbkAdminRedux/rtkq/current-user.slice';

// Re-export base selectors for backward compatibility
export {
  selectAppState,
  selectCompany,
  selectApp,
  selectCompanyName,
  selectAppDisplayName,
  selectCompanyInternalName,
  selectCompanyId,
  selectAppId,
} from './app-base-selectors';

export const selectUser = (state: DefaultRootState) => selectCurrentUser(state);
